import { EnvironmentGroupId } from '@/react/portainer/environments/types';

import { Directive } from '../../../types';

/**
 * Unified access entry for RBAC policies
 * Represents a user or team with a role
 */
export interface UnifiedAccess {
  Id: number;
  PartyId: number | null; // Id for user/team
  Type: 'user' | 'team' | '';
  Name: string; // Username for users, Name for teams
  Role: {
    Id: number | null;
    Name: string;
  };
}

/**
 * Complete form values for Docker RBAC Policy form.
 * Combines common policy fields with RBAC-specific fields.
 * Used by the self-contained DockerRBACPolicyForm component.
 */
export interface DockerRBACFormValues {
  /** Policy name */
  name: string;
  /** Environment group IDs */
  environmentGroupIds: Array<EnvironmentGroupId>;
  /** List of user/team access entries */
  accessList: UnifiedAccess[];
}

/**
 * Access policy value structure for backend
 */
export interface AccessPolicyValue {
  RoleId: Directive<number>;
}

/**
 * API payload for Docker RBAC Policy
 * Uses PascalCase to match backend expectations
 */
export interface DockerRBACPolicyPayload {
  EnvironmentAccessPolicies: {
    UserAccessPolicies: Record<string, AccessPolicyValue>;
    TeamAccessPolicies: Record<string, AccessPolicyValue>;
  };
}

/**
 * Default initial values for complete Docker RBAC Policy form
 */
export const DOCKER_RBAC_FORM_DEFAULT_VALUES: DockerRBACFormValues = {
  name: '',
  environmentGroupIds: [],
  accessList: [],
};
